import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel } from "@mui/material";
import { useId } from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
export const CheckboxInput = (props)=>{
    const labelId = useId();
    const errorId = useId();
    const formContext = useFormContext();
    const translation = useTranslation();
    const error = get(formContext.formState.errors, props.name);
    const onChange = (field, checked)=>{
        field.onChange(checked);
        props.onChange?.(checked);
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: formContext.control,
        name: props.name,
        render: ({ field })=>/*#__PURE__*/ _jsxs(FormControl, {
                error: !!error,
                fullWidth: props.fullWidth,
                required: props.required,
                children: [
                    props.label && /*#__PURE__*/ _jsx(FormLabel, {
                        disabled: props.disabled,
                        id: labelId,
                        required: props.required,
                        children: props.label
                    }),
                    /*#__PURE__*/ _jsx(FormControlLabel, {
                        control: /*#__PURE__*/ _jsx(Checkbox, {
                            "aria-describedby": errorId,
                            "aria-disabled": props.disabled,
                            "aria-labelledby": labelId,
                            checked: field.value || false,
                            disabled: props.disabled,
                            onChange: (e)=>onChange(field, e.target.checked),
                            required: props.required,
                            slotProps: {
                                input: {
                                    // @ts-expect-error: required for testing purposes
                                    'data-testid': props['data-testid'] || props.name,
                                    name: props.name
                                }
                            },
                            sx: props.alignTop ? {
                                py: 0.5
                            } : undefined
                        }),
                        label: props.option,
                        sx: props.alignTop ? {
                            alignItems: 'flex-start'
                        } : undefined
                    }),
                    !props.hideError && /*#__PURE__*/ _jsx(FormHelperText, {
                        id: errorId,
                        children: translation.t(error?.message) || ' '
                    })
                ]
            })
    });
};
CheckboxInput.displayName = 'CheckboxInput';

//# sourceMappingURL=CheckboxInput.js.map